"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../../core/utils/index");

var WindowItemPromoPriceDTO_1 = require("../model/WindowItemPromoPriceDTO");

var WindowItemPromoPriceDTOConverter_1 = require("./WindowItemPromoPriceDTOConverter");
/**
 * Implementation of WindowItemPromoPriceDTOConverter.
 * @author OPt
 */


var WindowItemPromoPriceDTOConverterImpl =
/*#__PURE__*/
function (_WindowItemPromoPrice) {
  _inherits(WindowItemPromoPriceDTOConverterImpl, _WindowItemPromoPrice);

  function WindowItemPromoPriceDTOConverterImpl() {
    _classCallCheck(this, WindowItemPromoPriceDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemPromoPriceDTOConverterImpl).apply(this, arguments));
  }

  _createClass(WindowItemPromoPriceDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new WindowItemPromoPriceDTO_1.WindowItemPromoPriceDTO(WindowItemPromoPriceDTO_1.WindowItemPromoPriceDTO.schema.windowItemId.valueOf(conversions.toClassReferenceId(source.windowItemId)), WindowItemPromoPriceDTO_1.WindowItemPromoPriceDTO.schema.promoPrice.valueOf(!index_1.Utils.isValueMissing(source.promoPrice) ? conversions.toBigNumber(source.promoPrice) : null));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        windowItemId: conversions.toDocumentReferenceId(source.windowItemId),
        promoPrice: index_1.Utils.isValueMissing(source.promoPrice) ? null : conversions.fromBigNumber(source.promoPrice)
      });
      return result;
    }
  }]);

  return WindowItemPromoPriceDTOConverterImpl;
}(WindowItemPromoPriceDTOConverter_1.WindowItemPromoPriceDTOConverter);

exports.WindowItemPromoPriceDTOConverterImpl = WindowItemPromoPriceDTOConverterImpl;